import * as THREE from 'three'
import React, { useMemo, useState } from 'react'
import { useThree } from '@react-three/fiber';

import { const_var, params } from '../../../../../../redux/reducers/reducer';
import { controls } from '../../../../../../redux/reducers/common/eventReducer';

import { CSG } from '../../../../../../assets/libs/csg-lib';
import { delModel, extrudeSettings, roofPattern, textureAnisotropy} from '../../../../../../utils/Functions';
import useMouseEvents from '../../../../../../hooks/useMouseEvents';
import { MaterialInnerWall, MaterialOuterWallNew, MaterialWainScotWallNew } from '../../../../CustomMaterial';

const WallModel = () => {
    const { gl } = useThree ();

    const [frontWallCloseState, setFrontWallCloseState] = useState(0);
    const [backWallCloseState, setBackWallCloseState] = useState(0);
    const [sideWallCloseState, setSideWallCloseState] = useState(0);
    const [sideWallLeftPorchSize, setSideWallLeftPorchSize] = useState(0);
    const [sideWallRightPorchSize, setSideWallRightPorchSize] = useState(0);
    // const [isStorageLeftWall, setIsStorageLeftWall] = useState(false);

    const wallThickness = 0.005;
    const cbFrontBackWallOffset = 0.16;
    const isEqualHeight = (params.leanR_p_h + ((params.b_l_t_r_pR / 12) * (params.leanR_p_w)) == params.p_h) ? 0.2 : 0

    const canvasElement = document.getElementsByClassName("buildingcanvas")
    const isPattern = (canvasElement != undefined && canvasElement[0]?.clientWidth > 1050 && !params.p_v_w) ? true : false
    
     

    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])

    let offset;
    if(params.leanR_p_d % legDistance === 0) offset = 0.15;
    else offset = 0;
    
    let verticalHorizontalPosF = {"x": params.p_w/2,"y" : ((params.p_w_c_n && params.p_b_c_b_r_f === 'Close') ? 2.935 : 0), "z" : params.leanR_p_d / 2 + 0.16}
    let verticalHorizontalRotF = {"x":0,"y" : Math.PI / 2,"z" : Math.PI / 2}
    let patternLength = params.leanR_p_h + ((params.b_l_t_r_pR / 12) * (params.leanR_p_w)) + ((params.p_w_c_n && params.p_b_c_b_r_f === 'Close') ? -2.935 : 0) + (params.p_r_s === 1 ? 3 : 0)
    let patternDepth = params.leanR_p_w
    let lengthPattern = 3
    let depthPattern = patternDepth

   
    // const meshFrontDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanFront', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
    
    //     let meshFrontDelModel_Temp = meshFrontDelModel.clone();
    //     meshFrontDelModel_Temp.position.set(0, 0, params.leanR_p_d / 2 - 0.5);
    //     meshFrontDelModel_Temp.updateMatrixWorld();


    const dutchDelModelFront = useMemo(() => {
        const freeSpace = 1;
        let cornerFreeSpaceW = (params.leanR_p_w - freeSpace) / 6;
        const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.leanR_p_h :  params.leanR_p_h
        let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
        if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

        if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
        if (params.add_right_lean && (params.p_b_c_b_r_f === "Half Dutch End" || params.p_b_c_b_r_f === "Half End")) {
            const model = new THREE.Shape();
            model.moveTo(-(params.leanR_p_w / 2 - freeSpace), 0);

            if (params.p_b_c_b_r_f === "Half Dutch End") {
                model.lineTo(-(params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo(-(params.leanR_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanR_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
            } else {
                model.lineTo(-(params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace);
            }
            model.lineTo((params.leanR_p_w / 2 - freeSpace), 0);

            return model;
        } else {
            return []
        }
    }, [params.add_right_lean, params.leanR_p_w, params.leanR_p_h, params.p_b_c_b_r_f])



    const dutchDelModelBack = useMemo(() => {
        const freeSpace = 1;
        let cornerFreeSpaceW = (params.leanR_p_w - freeSpace) / 6;
        const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.leanR_p_h:  params.leanR_p_h
        let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
        if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

        if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
        if (params.add_right_lean && (params.p_b_c_b_r_b === "Half Dutch End" || params.p_b_c_b_r_b === "Half End")) {
            const model = new THREE.Shape();
            model.moveTo(-(params.leanR_p_w / 2 - freeSpace), 0);

            if (params.p_b_c_b_r_b === "Half Dutch End") {
                model.lineTo(-(params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo(-(params.leanR_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanR_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
            } else {
                model.lineTo(-(params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace);
            }
            model.lineTo((params.leanR_p_w / 2 - freeSpace), 0);

            return model;
        } else {
            return []
        }
    }, [params.add_right_lean, params.leanR_p_w, params.leanR_p_h, params.p_b_c_b_r_b])
    
    // Front Wall - CSG    
    const frontWallModelObj = useMemo(() => {
        if(params.p_b_c_b_r_f == 'Open') return;
        let outerModel;
        let innerModel;
        let wainscotModel;
        
        //************************* */ inner wall geometry
        const frontWallModel = new THREE.Shape();
        if (params.p_b_c_b_r_f !== 'Open' || typeof(params.p_b_c_b_r_f) === 'object') {
            if (params.p_r_s === 1) {
                frontWallModel.moveTo(-(params.leanR_p_w - 0.005), frontWallCloseState);
                frontWallModel.lineTo(-(params.leanR_p_w - 0.005), params.leanR_p_h);
                frontWallModel.lineTo(-(params.leanR_p_w - 0.005), params.leanR_p_h + const_var.roofRegularDst);
                frontWallModel.quadraticCurveTo(-(params.leanR_p_w), params.leanR_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_pR / 12) / 10, 
                                                -(params.leanR_p_w - const_var.roofRegularDst + 0.1), params.leanR_p_h + const_var.roofRegularDst * (2 + params.b_l_t_r_pR / 12))
                frontWallModel.lineTo(0, params.leanR_p_h + ((params.b_l_t_r_pR / 12) * (params.leanR_p_w) + const_var.roofRegularDst * (2)));
                frontWallModel.lineTo(0, frontWallCloseState);
                frontWallModel.closePath();
            } else {
                frontWallModel.moveTo(-params.leanR_p_w + 0.005, params.leanR_p_h);
                frontWallModel.lineTo(0, params.leanR_p_h + params.leanR_p_w / 12 * params.b_l_t_r_pR - isEqualHeight);
                frontWallModel.lineTo(0, frontWallCloseState + (params.p_r_s === 1 && 0.1));
                frontWallModel.lineTo(-params.leanR_p_w + 0.005, frontWallCloseState + (params.p_r_s === 1 && 0.1));
                frontWallModel.closePath();
            }
        }
        const meshFrontWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(frontWallModel, extrudeSettings(0.005)));
        const meshFrontDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanFront', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        const meshDutchDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(dutchDelModelFront, extrudeSettings(1)), new THREE.MeshStandardMaterial({color: 'blue'}))

        let meshFrontWallModel_Temp = meshFrontWallModel.clone();
        meshFrontWallModel_Temp.rotateY(Math.PI)
        meshFrontWallModel_Temp.position.set(params.p_w / 2, 0, params.leanR_p_d / 2 + cbFrontBackWallOffset + wallThickness - 0.05);
        meshFrontWallModel_Temp.updateMatrixWorld();
    
        let meshFrontDelModel_Temp = meshFrontDelModel.clone();
        meshFrontDelModel_Temp.position.set(0, 0, params.leanR_p_d / 2 - 0.5);
        meshFrontDelModel_Temp.updateMatrixWorld();

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(params.p_w / 2 + params.leanR_p_w - 0.2, 0, -params.leanR_p_pos);
        meshSideDelModel_Temp.rotateY(Math.PI / 2);
        meshSideDelModel_Temp.updateMatrixWorld();

        let meshDutchDelModel_Temp = meshDutchDelModel.clone();
        meshDutchDelModel_Temp.position.set((params.p_w / 2 + params.leanR_p_w / 2),0, params.leanR_p_d / 2 - 0.5);
        meshDutchDelModel_Temp.updateMatrixWorld();
    
        const meshFrontWallModel_CSG = CSG.fromMesh(meshFrontWallModel_Temp);
        const meshFrontDelModel_CSG = CSG.fromMesh(meshFrontDelModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);
        const meshDutchDelModel_CSG = CSG.fromMesh(meshDutchDelModel_Temp);
    
        const frontWallModel_CSG = meshFrontWallModel_CSG.subtract(meshFrontDelModel_CSG);
        const meshSideInnerDelModel_CSG =  frontWallModel_CSG.subtract(meshSideDelModel_CSG);
        const meshFrontInnerModel_CSG = meshSideInnerDelModel_CSG.subtract(meshDutchDelModel_CSG);

        const CSGFrontWallModel = CSG.toMesh(
            meshFrontInnerModel_CSG,
            new THREE.Matrix4()
        )

        innerModel = CSGFrontWallModel.geometry

        //************************* */ outer wall geomety (grooves pattern)
        const frontWallCutModel = new THREE.Shape();
        if (params.p_r_s === 1) {
            frontWallCutModel.moveTo((params.p_w / 2 + params.leanR_p_w), frontWallCloseState);
            frontWallCutModel.lineTo((params.p_w / 2 + params.leanR_p_w), params.leanR_p_h);
            frontWallCutModel.lineTo((params.p_w / 2 + params.leanR_p_w), params.leanR_p_h + const_var.roofRegularDst);
            frontWallCutModel.quadraticCurveTo((params.p_w / 2 + params.leanR_p_w), params.leanR_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_pR / 12) / 10, 
                                               (params.p_w / 2 + params.leanR_p_w - const_var.roofRegularDst + 0.1), params.leanR_p_h + const_var.roofRegularDst * (2 + params.b_l_t_r_pR / 12))
            frontWallCutModel.lineTo((params.p_w / 2), params.leanR_p_h + ((params.b_l_t_r_pR / 12) * (params.leanR_p_w) + const_var.roofRegularDst * (2)));
            frontWallCutModel.lineTo((params.p_w / 2), frontWallCloseState);
            frontWallCutModel.closePath();
        } else {
            frontWallCutModel.moveTo((params.p_w / 2), params.leanR_p_h + ((params.b_l_t_r_pR / 12) * (params.leanR_p_w)) - isEqualHeight); //right lean left top
            frontWallCutModel.lineTo((params.p_w / 2 + params.leanR_p_w), params.leanR_p_h); //right lean right top
            frontWallCutModel.lineTo((params.p_w / 2 + params.leanR_p_w), frontWallCloseState); //right lean right bottom
            frontWallCutModel.lineTo((params.p_w / 2), frontWallCloseState); //right lean left bottom
            frontWallCutModel.closePath();
        }
 
        const meshWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLength,isPattern), extrudeSettings(patternDepth)))  
        const meshGableDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(frontWallCutModel, extrudeSettings(1)))
    
        let meshGableDelModel_Temp = meshGableDelModel.clone();
        meshGableDelModel_Temp.position.set(0,0,params.leanR_p_d / 2 - 0.5);
        meshGableDelModel_Temp.updateMatrixWorld();
    
        let meshWallModel_Temp = meshWallModel.clone();
        meshWallModel_Temp.position.set(verticalHorizontalPosF.x,verticalHorizontalPosF.y,verticalHorizontalPosF.z);
        meshWallModel_Temp.rotation.set(verticalHorizontalRotF.x,verticalHorizontalRotF.y,verticalHorizontalRotF.z);
        meshWallModel_Temp.updateMatrixWorld();

        let meshSideOuterDelModel_Temp = meshSideDelModel.clone();
        meshSideOuterDelModel_Temp.position.set(params.p_w / 2 + params.leanR_p_w - 0.2, 0, -params.leanR_p_pos);
        meshSideOuterDelModel_Temp.rotateY(Math.PI / 2);
        meshSideOuterDelModel_Temp.updateMatrixWorld();
    
        const meshWallModel_CSG = CSG.fromMesh(meshWallModel_Temp);
        const meshGableDelModel_CSG = CSG.fromMesh(meshGableDelModel_Temp);
        const meshSideOuterDelModel_CSG = CSG.fromMesh(meshSideOuterDelModel_Temp);
    
        const wallModel_CSG = meshWallModel_CSG.subtract(meshFrontDelModel_CSG);
        const GableModel_CSG = wallModel_CSG.intersect(meshGableDelModel_CSG);
        const SideOuterDelModel_CSG = GableModel_CSG.subtract(meshSideOuterDelModel_CSG);
        const MeshFrontOuterModel_CSG = SideOuterDelModel_CSG.subtract(meshDutchDelModel_CSG);
    
        const CSGWallModel = CSG.toMesh(MeshFrontOuterModel_CSG,new THREE.Matrix4());

        outerModel = CSGWallModel.geometry;

        //************************* */ wainscot wall geometry
        let wainscotVerticalHorizontalPosF = {"x": params.p_w/2,"y" : 0, "z" : params.leanR_p_d / 2 + 0.16}
        let wainscotVerticalHorizontalRotF = {"x":0,"y" : Math.PI / 2,"z" : Math.PI / 2}
        let patternDepthWS = params.leanR_p_w
        let lengthPatternWS = 3
        let depthPatternWS = patternDepthWS

        const meshFrontWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternWS,isPattern && params.wainscotTexture == "none"), extrudeSettings(depthPatternWS)))

        let meshFrontWainscotModel_Temp = meshFrontWainscotModel.clone();
        meshFrontWainscotModel_Temp.position.set(wainscotVerticalHorizontalPosF.x,wainscotVerticalHorizontalPosF.y,wainscotVerticalHorizontalPosF.z);
        meshFrontWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRotF.x,wainscotVerticalHorizontalRotF.y,wainscotVerticalHorizontalRotF.z);
        meshFrontWainscotModel_Temp.updateMatrixWorld();

        const meshFrontWainscotModel_CSG = CSG.fromMesh(meshFrontWainscotModel_Temp);

        const frontWainscotModel_CSG = meshFrontWainscotModel_CSG.subtract(meshFrontDelModel_CSG);
        const sideDelWainscotModel_CSG = frontWainscotModel_CSG.subtract(meshSideOuterDelModel_CSG);
        const finalFrontwainscotModel_CSG = sideDelWainscotModel_CSG.subtract(meshDutchDelModel_CSG);

        const CSGFrontWainscotModel = CSG.toMesh(
            finalFrontwainscotModel_CSG,
            new THREE.Matrix4()
            )

        wainscotModel = CSGFrontWainscotModel.geometry;

        return {outerModel, innerModel, wainscotModel};
     
    }, [params.wallTexture,params.wainscotTexture,params.p_b_c_b_r_f, params.p_r_s, params.leanR_p_w, params.leanR_p_h, params.b_l_t_r_pR, params.leanR_p_pos,  frontWallCloseState, params.p_h, params.p_w, params.p_r_p, verticalHorizontalPosF, verticalHorizontalRotF, lengthPattern, depthPattern, patternLength, patternDepth, params.p_v_w, params.leanR_p_d, const_var.newDoorsArray, params.p_w_c_n, isPattern])

    const sideWallModelObj = useMemo(() => {
        if(params.p_b_c_b_r == 'Open' && !params.add_storage_check_right) return;
        let outerModel;
        let innerModel;
        let wainscotModel;

        let verticalDepth = params.leanR_p_d
        let horizontalDepth = params.leanR_p_d
        let VSPosition = params.leanR_p_d / -2
        let HSPosition = params.leanR_p_d / 2

        if(!params.add_right_front_lean_porch && params.add_right_back_lean_porch){
            VSPosition = params.leanR_p_d / -2 - params.leanR_p_w
            verticalDepth = params.leanR_p_d +  params.leanR_p_w
            horizontalDepth = params.leanR_p_d +  params.leanR_p_w
        } else if(params.add_right_front_lean_porch && !params.add_right_back_lean_porch){
            VSPosition = params.leanR_p_d / -2
            HSPosition = params.leanR_p_d / 2 + params.leanR_p_w
            verticalDepth = params.leanR_p_d +  params.leanR_p_w
            horizontalDepth = params.leanR_p_d +  params.leanR_p_w
        } else if(params.add_right_front_lean_porch && params.add_right_back_lean_porch){
            VSPosition = params.leanR_p_d / -2 - params.leanR_p_w
            HSPosition = params.leanR_p_d / 2 + params.leanR_p_w
            verticalDepth = params.leanR_p_d +  params.leanR_p_w + params.leanR_p_w
            horizontalDepth = params.leanR_p_d +  params.leanR_p_w + params.leanR_p_w
        }
    
        let verticalHorizontalPosS = {"x": params.p_w / 2  + params.leanR_p_w,"y" : ((params.p_w_c_n && (params.p_b_c_b_r === 'Close' || params.add_storage_check_right)) ? 2.935 : 0), "z" : HSPosition}
        let verticalHorizontalRotS = {"x":0,"y" : Math.PI,"z" : Math.PI / 2}
        let patternLengthS = params.leanR_p_h - 0.1 + ((params.p_w_c_n && (params.p_b_c_b_r === 'Close' || params.add_storage_check_right)) ? -2.935 : 0) + (params.p_r_s === 1 ? 0.2 : 0)
        let patternDepthS = horizontalDepth
        
        let lengthR = params.leanR_p_d / 2
        let lengthL = params.leanR_p_d / 2

        if(params.add_right_front_lean_porch && !params.add_right_back_lean_porch){
            lengthR = params.leanR_p_d / 2 + params.leanR_p_w
        } else if(!params.add_right_front_lean_porch && params.add_right_back_lean_porch){
            lengthL = params.leanR_p_d / 2 + params.leanR_p_w
        } else if(params.add_right_front_lean_porch && params.add_right_back_lean_porch){
            lengthL = params.leanR_p_d / 2 + params.leanR_p_w
            lengthR = params.leanR_p_d / 2 + params.leanR_p_w
        }

        let wallpanelValue = (sideWallCloseState < 0) ? params.leanR_p_h + (params.p_r_s === 1 && 0.1) : sideWallCloseState
       
        //************************* */ inner wall geometry        
        const sideWallModel = new THREE.Shape();
        sideWallModel.moveTo(-(params.leanR_p_d / 2 + cbFrontBackWallOffset), sideWallCloseState);
        sideWallModel.lineTo(-(params.leanR_p_d / 2 + cbFrontBackWallOffset), sideWallCloseState);
        sideWallModel.lineTo(-(params.leanR_p_d / 2 + sideWallRightPorchSize + cbFrontBackWallOffset), sideWallCloseState);
        sideWallModel.lineTo(-(params.leanR_p_d / 2 + sideWallRightPorchSize + cbFrontBackWallOffset), params.leanR_p_h + (params.p_r_s === 1 && 0.1));
        sideWallModel.lineTo((params.leanR_p_d / 2 + cbFrontBackWallOffset) + sideWallLeftPorchSize, params.leanR_p_h + (params.p_r_s === 1 && 0.1));
        sideWallModel.lineTo((params.leanR_p_d / 2 + cbFrontBackWallOffset) + sideWallLeftPorchSize, sideWallCloseState);
        sideWallModel.lineTo(((params.leanR_p_d / 2 + cbFrontBackWallOffset)), sideWallCloseState);
        sideWallModel.closePath();

        const storageSideWallModel = new THREE.Shape();
        storageSideWallModel.moveTo(-(params.leanR_p_d / 2), 0);
        storageSideWallModel.lineTo((-params.leanR_p_d / 2 + parseInt(params.add_storage_right)), 0);
        storageSideWallModel.lineTo((-params.leanR_p_d / 2 + parseInt(params.add_storage_right)), params.leanR_p_h + (params.p_r_s === 1 && -0.15));
        storageSideWallModel.lineTo(-(params.leanR_p_d / 2), params.leanR_p_h + (params.p_r_s === 1 && -0.15));
        storageSideWallModel.closePath();

        const meshSideWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(sideWallModel, extrudeSettings(0.005)));
        const meshStorageSideWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageSideWallModel, extrudeSettings(1)));
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
    
        let meshSideWallModel_Temp = meshSideWallModel.clone();
        meshSideWallModel_Temp.rotateY(-Math.PI / 2);
        meshSideWallModel_Temp.position.set(params.p_w / 2 + params.leanR_p_w - 0.03, 0, 0);
        meshSideWallModel_Temp.updateMatrixWorld();

        let meshStorageSideWallModel_Temp = meshStorageSideWallModel.clone();
        meshStorageSideWallModel_Temp.rotateY(-Math.PI / 2);
        meshStorageSideWallModel_Temp.position.set(params.p_w / 2 + params.leanR_p_w + 0.5, 0, params.rightLeanStoragePosition);
        meshStorageSideWallModel_Temp.updateMatrixWorld();
    
        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.rotateY(Math.PI / 2)
        // meshSideDelModel_Temp.position.set(params.p_w / 2 + params.leanR_p_w -0.5, 0, -alignPosOffset);
        meshSideDelModel_Temp.position.set(params.p_w / 2 + params.leanR_p_w -0.5, 0, -params.leanR_p_pos);
        meshSideDelModel_Temp.updateMatrixWorld();
    
        const meshSideWallModel_CSG = CSG.fromMesh(meshSideWallModel_Temp);
        const meshStorageSideWallModel_CSG = CSG.fromMesh(meshStorageSideWallModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);
    
        const sideWallModel_CSG = meshSideWallModel_CSG.subtract(meshSideDelModel_CSG);

        let storageWallDelModel_CSG;

        if(params.add_storage_check_right) {
            storageWallDelModel_CSG = sideWallModel_CSG.subtract(meshStorageSideWallModel_CSG)
        } else {
            storageWallDelModel_CSG = sideWallModel_CSG
        }

        const CSGSideWallModel = CSG.toMesh(
            storageWallDelModel_CSG,
            new THREE.Matrix4()
        )

        innerModel = CSGSideWallModel.geometry;

        //************************* */ outer wall geometry
        const sideWallCutModel = new THREE.Shape();
        sideWallCutModel.moveTo(lengthR, params.leanR_p_h  + (params.p_r_s === 1 && 0.1));
        sideWallCutModel.lineTo(-(lengthL), params.leanR_p_h  + (params.p_r_s === 1 && 0.1));
        sideWallCutModel.lineTo(-(lengthL), wallpanelValue );
        sideWallCutModel.lineTo(lengthR, wallpanelValue );
        sideWallCutModel.closePath();

        const meshSideWallModelPattern = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLengthS,isPattern), extrudeSettings(patternDepthS)));

        const meshWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(sideWallCutModel, extrudeSettings(1)))
        
        let meshWallModel_TempS = meshSideWallModelPattern.clone();
        meshWallModel_TempS.position.set(verticalHorizontalPosS.x,verticalHorizontalPosS.y,verticalHorizontalPosS.z);
        meshWallModel_TempS.rotation.set(verticalHorizontalRotS.x,verticalHorizontalRotS.y,verticalHorizontalRotS.z);
        meshWallModel_TempS.updateMatrixWorld();
    
        let meshWallDelModel_TempS = meshWallDelModel.clone();
        meshWallDelModel_TempS.position.set(params.p_w / 2 + params.leanR_p_w + 0.5 , 0, 0);
        meshWallDelModel_TempS.rotation.set(0,Math.PI / -2,0)
        meshWallDelModel_TempS.updateMatrixWorld();
    
        const meshWallModel_CSGS = CSG.fromMesh(meshWallModel_TempS);
        const meshWallDelModel_CSGS = CSG.fromMesh(meshWallDelModel_TempS);

        const wallModel_CSGS = meshWallModel_CSGS.subtract(meshSideDelModel_CSG);
        const meshWallDel_CSGS = wallModel_CSGS.intersect(meshWallDelModel_CSGS);
        
        let storageWallDelModel_CSGS;

        if(params.add_storage_check_right) {
            storageWallDelModel_CSGS = meshWallDel_CSGS.subtract(meshStorageSideWallModel_CSG)
        } else {
            storageWallDelModel_CSGS = meshWallDel_CSGS
        }
        const CSGWallModelS = CSG.toMesh(storageWallDelModel_CSGS,new THREE.Matrix4());

        outerModel = CSGWallModelS.geometry

        //************************* */ wainscot wall geometry
        let wainscotVerticalHorizontalPosS = {"x": params.p_w / 2  + params.leanR_p_w,"y" : 0, "z" : HSPosition}
        let wainscotVerticalHorizontalRotS = {"x":0,"y" : Math.PI,"z" : Math.PI / 2}
        let patternDepthSWS = horizontalDepth
        let lengthPatternS = 3
        let depthPatternS = patternDepthSWS

        const meshSideWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternS,isPattern && params.wainscotTexture == "none"), extrudeSettings(depthPatternS)))
        let meshSideWainscotModel_Temp = meshSideWainscotModel.clone();
        meshSideWainscotModel_Temp.position.set(wainscotVerticalHorizontalPosS.x,wainscotVerticalHorizontalPosS.y,wainscotVerticalHorizontalPosS.z);
        meshSideWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRotS.x,wainscotVerticalHorizontalRotS.y,wainscotVerticalHorizontalRotS.z);
        meshSideWainscotModel_Temp.updateMatrixWorld();

        const meshSideWainscotModel_CSG = CSG.fromMesh(meshSideWainscotModel_Temp);


        const SideWainscotModel_CSG = meshSideWainscotModel_CSG.subtract(meshSideDelModel_CSG);
        const SideWainscotModelCSG = SideWainscotModel_CSG.intersect(meshWallDelModel_CSGS);

        let storageWainscotDelModel_CSG;

        if(params.add_storage_check_right) {
            storageWainscotDelModel_CSG = SideWainscotModelCSG.subtract(meshStorageSideWallModel_CSG)
        } else {
            storageWainscotDelModel_CSG = SideWainscotModelCSG
        }

        const CSGSideWainscotModel = CSG.toMesh(
            storageWainscotDelModel_CSG,
            new THREE.Matrix4()
            )

        wainscotModel = CSGSideWainscotModel.geometry;

        return {outerModel, innerModel, wainscotModel}
    
    }, [params.wallTexture,params.wainscotTexture,params.p_w, params.leanR_p_h, params.p_r_s,sideWallCloseState,params.leanR_p_d, params.rightLeanStoragePosition, params.add_storage_right, params.add_storage_check_right,params.add_right_front_lean_porch, params.add_right_back_lean_porch, sideWallLeftPorchSize, sideWallRightPorchSize, params.p_w_c_n, params.leanR_p_w, params.p_v_w, const_var.newDoorsArray,params.p_b_c_b_r, isPattern])

    // Back Wall - CSG
    const backWallModelObj = useMemo(() => {
        if(params.p_b_c_b_r_b == 'Open' && !params.add_storage_check_right) return;
        let outerModel;
        let innerModel;
        let wainscotModel;

        //************************* */ inner wall geometry
        const backWallModel = new THREE.Shape();
        if (params.p_b_c_b_r_b !== 'Open' || typeof(params.p_b_c_b_r_b) === 'object') {
            if (params.p_r_s === 1) {
                backWallModel.moveTo(-(params.leanR_p_w - 0.005), backWallCloseState);
                backWallModel.lineTo(-(params.leanR_p_w - 0.005), params.leanR_p_h);
                backWallModel.lineTo(-(params.leanR_p_w - 0.005), params.leanR_p_h + const_var.roofRegularDst);
                backWallModel.quadraticCurveTo(-(params.leanR_p_w), params.leanR_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_pR / 12) / 10, 
                                                -(params.leanR_p_w - const_var.roofRegularDst + 0.1), params.leanR_p_h + const_var.roofRegularDst * (2 + params.b_l_t_r_pR / 12))
                backWallModel.lineTo(0, params.leanR_p_h + ((params.b_l_t_r_pR / 12) * (params.leanR_p_w) + const_var.roofRegularDst * (2)));
                backWallModel.lineTo(0, backWallCloseState);
                backWallModel.closePath();
            } else {
                backWallModel.moveTo(-params.leanR_p_w + 0.005, params.leanR_p_h);
                backWallModel.lineTo(0, params.leanR_p_h + params.leanR_p_w / 12 * params.b_l_t_r_pR - isEqualHeight);
                backWallModel.lineTo(0, backWallCloseState + (params.p_r_s === 1 && 0.1));
                backWallModel.lineTo(-params.leanR_p_w + 0.005, backWallCloseState + (params.p_r_s === 1 && 0.1));
                backWallModel.closePath();
            }
        }

        const meshBackWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(backWallModel, extrudeSettings(0.005)));
        const meshBackDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanBack', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        const meshDutchDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(dutchDelModelBack, extrudeSettings(1)), new THREE.MeshStandardMaterial({color: 'blue'}))

        let meshBackWallModel_Temp = meshBackWallModel.clone();
        meshBackWallModel_Temp.rotateY(Math.PI)
        meshBackWallModel_Temp.position.set(params.p_w / 2, 0, -params.leanR_p_d / 2 - cbFrontBackWallOffset + wallThickness + 0.03);
        meshBackWallModel_Temp.updateMatrixWorld();
    
        let meshBackDelModel_Temp = meshBackDelModel.clone();
        meshBackDelModel_Temp.position.set(0, 0, -params.leanR_p_d / 2 - 0.5);
        meshBackDelModel_Temp.updateMatrixWorld();

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(params.p_w / 2 + params.leanR_p_w - 0.2, 0, -params.leanR_p_pos);
        meshSideDelModel_Temp.rotateY(Math.PI / 2);
        meshSideDelModel_Temp.updateMatrixWorld();

        let meshDutchDelModel_Temp = meshDutchDelModel.clone();
        meshDutchDelModel_Temp.position.set((params.p_w / 2 + params.leanR_p_w / 2),0, - params.leanR_p_d / 2 - 0.5);
        meshDutchDelModel_Temp.updateMatrixWorld();
    
        const meshBackWallModel_CSG = CSG.fromMesh(meshBackWallModel_Temp);
        const meshBackDelModel_CSG = CSG.fromMesh(meshBackDelModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);
        const meshDutchDelModel_CSG = CSG.fromMesh(meshDutchDelModel_Temp);
    
        const backWallModel_CSG = meshBackWallModel_CSG.subtract(meshBackDelModel_CSG);
        const meshSideInnerDelModel_CSG =  backWallModel_CSG.subtract(meshSideDelModel_CSG);
        const meshBackInnerModel_CSG = meshSideInnerDelModel_CSG.subtract(meshDutchDelModel_CSG);

        const CSGBackWallModel = CSG.toMesh(
            meshBackInnerModel_CSG,
            new THREE.Matrix4()
        )
    
        innerModel = CSGBackWallModel.geometry;

        //************************* */ outer wall geometry
        let verticalHorizontalPosB = {"x": params.p_w / 2 + params.leanR_p_w ,"y" : ((params.p_w_c_n && params.p_b_c_b_r_b === 'Close') ? 2.935 : 0), "z" : params.leanR_p_d / -2 - 0.16}
        let verticalHorizontalRotB = {"x":0,"y" : Math.PI / -2,"z" : Math.PI / 2}
        let patternLengthB = params.leanR_p_h + ((params.b_l_t_r_pR / 12) * (params.leanR_p_w)) + ((params.p_w_c_n && params.p_b_c_b_r_b === 'Close') ? -2.935 : 0) + (params.p_r_s === 1 ? 3 : 0)
        let patternDepthB = params.leanR_p_w

        const backWallCutModel = new THREE.Shape();
        if (params.p_r_s === 1) {
            backWallCutModel.moveTo((params.p_w / 2 + params.leanR_p_w), backWallCloseState);
            backWallCutModel.lineTo((params.p_w / 2 + params.leanR_p_w), params.leanR_p_h);
            backWallCutModel.lineTo((params.p_w / 2 + params.leanR_p_w), params.leanR_p_h + const_var.roofRegularDst);
            backWallCutModel.quadraticCurveTo((params.p_w / 2 + params.leanR_p_w), params.leanR_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_pR / 12) / 10, 
                                              (params.p_w / 2 + params.leanR_p_w - const_var.roofRegularDst + 0.1), params.leanR_p_h + const_var.roofRegularDst * (2 + params.b_l_t_r_pR / 12))
            backWallCutModel.lineTo((params.p_w / 2), params.leanR_p_h + ((params.b_l_t_r_pR / 12) * (params.leanR_p_w) + const_var.roofRegularDst * (2)));
            backWallCutModel.lineTo((params.p_w / 2), backWallCloseState);
            backWallCutModel.closePath();
        } else {
            backWallCutModel.moveTo((params.p_w / 2), params.leanR_p_h + ((params.b_l_t_r_pR / 12) * (params.leanR_p_w)) - isEqualHeight); //right lean left top
            backWallCutModel.lineTo((params.p_w / 2 + params.leanR_p_w), params.leanR_p_h); //right lean right top
            backWallCutModel.lineTo((params.p_w / 2 + params.leanR_p_w), backWallCloseState); //right lean right bottom
            backWallCutModel.lineTo((params.p_w / 2), backWallCloseState); //right lean left bottom
            backWallCutModel.closePath();
        }
    
        const meshWallModelB = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLengthB,isPattern), extrudeSettings(patternDepthB)))  
        const meshGableDelModelB = new THREE.Mesh(new THREE.ExtrudeGeometry(backWallCutModel, extrudeSettings(1)))
    
        let meshGableDelModel_TempB = meshGableDelModelB.clone();
        meshGableDelModel_TempB.position.set(0,0,params.leanR_p_d / - 2 - 0.5);
        meshGableDelModel_TempB.updateMatrixWorld();
    
        let meshWallModel_TempB = meshWallModelB.clone();
        meshWallModel_TempB.position.set(verticalHorizontalPosB.x,verticalHorizontalPosB.y,verticalHorizontalPosB.z);
        meshWallModel_TempB.rotation.set(verticalHorizontalRotB.x,verticalHorizontalRotB.y,verticalHorizontalRotB.z);
        meshWallModel_TempB.updateMatrixWorld();

        let meshSideOuterDelModel_Temp = meshSideDelModel.clone();
        meshSideOuterDelModel_Temp.position.set(params.p_w / 2 + params.leanR_p_w - 0.2, 0, -params.leanR_p_pos);
        meshSideOuterDelModel_Temp.rotateY(Math.PI / 2);
        meshSideOuterDelModel_Temp.updateMatrixWorld();
    
        const meshWallModel_CSGB = CSG.fromMesh(meshWallModel_TempB);
        const meshGableDelModel_CSGB = CSG.fromMesh(meshGableDelModel_TempB);
        const meshSideOuterDelModel_CSG = CSG.fromMesh(meshSideOuterDelModel_Temp);
    
        const wallModel_CSGB = meshWallModel_CSGB.subtract(meshBackDelModel_CSG);
        const GableModel_CSGB = wallModel_CSGB.intersect(meshGableDelModel_CSGB);
        const SideOuterDelModel_CSG = GableModel_CSGB.subtract(meshSideOuterDelModel_CSG);
        const MeshFrontOuterModel_CSG = SideOuterDelModel_CSG.subtract(meshDutchDelModel_CSG);
    
        const CSGWallModelB = CSG.toMesh(MeshFrontOuterModel_CSG,new THREE.Matrix4())

        outerModel = CSGWallModelB.geometry;

        //************************* */ wainscot wall geometry
        let patternDepthBWS = params.leanR_p_w
        let wainscotVerticalHorizontalPosB = {"x": params.p_w / 2 + params.leanR_p_w ,"y" : 0, "z" : params.leanR_p_d / -2 - 0.16}
        let wainscotVerticalHorizontalRotB = {"x":0,"y" : Math.PI / -2,"z" : Math.PI / 2}
        let lengthPatternB = 3
        let depthPatternB = patternDepthBWS

        const meshBackWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternB,isPattern && params.wainscotTexture == "none"), extrudeSettings(depthPatternB)))
        let meshBackWainscotModel_Temp = meshBackWainscotModel.clone();
        meshBackWainscotModel_Temp.position.set(wainscotVerticalHorizontalPosB.x,wainscotVerticalHorizontalPosB.y,wainscotVerticalHorizontalPosB.z);
        meshBackWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRotB.x,wainscotVerticalHorizontalRotB.y,wainscotVerticalHorizontalRotB.z);
        meshBackWainscotModel_Temp.updateMatrixWorld();

        const meshBackWainscotModel_CSG = CSG.fromMesh(meshBackWainscotModel_Temp);

        const backWainscotModel_CSG = meshBackWainscotModel_CSG.subtract(meshBackDelModel_CSG);
        const sideDelWainscotModel_CSG = backWainscotModel_CSG.subtract(meshSideOuterDelModel_CSG);
        const finalFrontwainscotModel_CSG = sideDelWainscotModel_CSG.subtract(meshDutchDelModel_CSG);

        const CSGBackWainscotModel = CSG.toMesh(
            finalFrontwainscotModel_CSG,
            new THREE.Matrix4()
            )

        wainscotModel = CSGBackWainscotModel.geometry;

        return {outerModel, innerModel, wainscotModel}
    
    }, [params.rightLeanStoragePosition, params.wallTexture,params.wainscotTexture,params.p_v_w, params.p_h, params.p_w, params.leanR_p_pos, params.p_r_p, params.p_b_c_b_r_b, params.p_r_s, params.leanR_p_w, params.b_l_t_r_pR, params.leanR_p_d, params.leanR_p_h, backWallCloseState, const_var.newDoorsArray, params.p_w_c_n, params.p_b_c_b_r_b, isPattern]);
    
     

    // --- front wall set    
    useMemo(() => {
        let tempWallCloseState;
        if (params.p_b_c_b_r_f === "Gable") {
            if (params.p_r_s === 1) {
                tempWallCloseState = params.leanR_p_h + 0.1;
            } else {
                tempWallCloseState = params.leanR_p_h - 0.2;
            }
        } else if (params.p_b_c_b_r_f === "One_Fourth_Close") {
            tempWallCloseState = params.leanR_p_h / 4 * 3;
        } else if (params.p_b_c_b_r_f === "Half_Close") {
            tempWallCloseState = params.leanR_p_h / 2;
        } else if (params.p_b_c_b_r_f === "Three_Fourth_Close") {
            tempWallCloseState = params.leanR_p_h / 4;
        } else if (params.p_b_c_b_r_f === "Close") {
            tempWallCloseState = 0;
        } else if (params.p_b_c_b_r_f === "Half Dutch End") {
            tempWallCloseState = 0;
        } else if (params.p_b_c_b_r_f === "Half End") {
            tempWallCloseState = 0;
        } else {
            tempWallCloseState = -1;
        }

        // if(params.p_w_c_n && params.p_b_c_b_r_f == "Close") tempWallCloseState = 3;

        setFrontWallCloseState(tempWallCloseState);
    }, [params.p_b_c_b_r_f, params.leanR_p_h, params.p_r_s, params.p_w_c_n])

    // --- back wall set    
    useMemo(() => {
        let tempWallCloseState;
        if (params.p_b_c_b_r_b === "Gable") {
            if (params.p_r_s === 1) {
                tempWallCloseState = params.leanR_p_h + 0.1;
            } else {
                tempWallCloseState = params.leanR_p_h - 0.2;
            }
        } else if (params.p_b_c_b_r_b === "One_Fourth_Close") {
            tempWallCloseState = params.leanR_p_h / 4 * 3;
        } else if (params.p_b_c_b_r_b === "Half_Close") {
            tempWallCloseState = params.leanR_p_h / 2;
        } else if (params.p_b_c_b_r_b === "Three_Fourth_Close") {
            tempWallCloseState = params.leanR_p_h / 4;
        } else if (params.p_b_c_b_r_b === "Close") {
            tempWallCloseState = 0;
        } else if (params.p_b_c_b_r_b === "Half Dutch End") {
            tempWallCloseState = 0;
        } else if (params.p_b_c_b_r_b === "Half End") {
            tempWallCloseState = 0;
        } else {
            tempWallCloseState = -1;
        }
        // if(params.p_w_c_n && params.p_b_c_b_r_b == "Close") tempWallCloseState = 3;

        setBackWallCloseState(tempWallCloseState);
    }, [params.add_storage_check_right, params.p_b_c_b_r_b, params.leanR_p_h, params.p_r_s, params.p_w_c_n])

    // --- side wall set    
    useMemo(() => {
        let tempWallCloseState = 0;
        if (params.p_b_c_b_r === 'Open' || typeof(params.p_b_c_b_r) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseState = params.leanR_p_h + 0.1;
            } else {
                tempWallCloseState = params.leanR_p_h;
            }
        } else if (params.p_b_c_b_r === "One_Fourth_Close") {
            tempWallCloseState = params.leanR_p_h / 4 * 3;
        } else if (params.p_b_c_b_r === "Half_Close") {
            tempWallCloseState = params.leanR_p_h / 2;
        } else if (params.p_b_c_b_r === "Three_Fourth_Close") {
            tempWallCloseState = params.leanR_p_h / 4;
        } else if (params.p_b_c_b_r === "Close") {
            tempWallCloseState = 0;
        } else {
            tempWallCloseState = params.leanR_p_h - 3 * params.p_b_c_b_r;
        }
        // if(params.p_w_c_n && params.p_b_c_b_r == "Close") tempWallCloseState = 3;

        setSideWallCloseState(tempWallCloseState);
    }, [params.p_b_c_b_r, params.leanR_p_h, params.p_r_s, params.p_w_c_n])
    
    // --- porch state
    useMemo(() => {
        if (params.add_right_front_lean_porch) {
            setSideWallLeftPorchSize(params.leanR_p_w);
        } else {
            setSideWallLeftPorchSize(0);
        }
    }, [params.add_right_front_lean_porch, params.leanR_p_w, params.p_r_s])

    useMemo(() => {
        if (params.add_right_back_lean_porch) {
            setSideWallRightPorchSize(params.leanR_p_w);
        } else {
            setSideWallRightPorchSize(0);
        }
    }, [params.add_right_back_lean_porch, params.leanR_p_w, params.p_r_s])

    // useMemo(() => {
    //     let array = const_var.newDoorsArray.filter((item) => item.userData.wallName === 'c_b_r_w' && item.height > params.leanR_p_h);
    //     for(let i=0; i<array.length; i++) {
    //         let item = array[i];
    //         const doorPositionX = item.positionX;
    //         const doorWidth = item.width
    //         const LeftStoragePos = params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right)
    //         const RightStoragePos = params.leanR_p_pos - params.leanR_p_d / 2
    //         if((RightStoragePos >= (doorPositionX - doorWidth / 2)) && (LeftStoragePos <= (doorPositionX + doorWidth / 2))){
    //             setIsStorageLeftWall(true)
    //             return;
    //         } 
    //         setIsStorageLeftWall(false)
    //     }

    // }, [const_var.newDoorsArray, params.leanR_p_pos, params.leanR_p_d, params.add_storage_right, params.leanR_p_h])

    const handleMouseEvent = (e) => {
        if (controls.isCheckActiveTab === 'doorwindow' && (const_var.focusedSection === "rightlean" && (params.activeWall === "R_L_F_S_W" || params.activeWall === "R_L_B_S_W"))) {
            switch (e.type) {
                case 'pointerdown':
                case 'click':
                case 'pointermove':
                    e.stopPropagation();
                    break;
                default :
                    break
            }
        }
    };
    const eventHandlers = useMouseEvents(handleMouseEvent);

    return (
        <>
            <group {...eventHandlers}>
                {(params.p_b_c_b_r !== 'Open') && sideWallModelObj?.outerModel &&
                    <mesh name="R_L_R_W" geometry={sideWallModelObj?.outerModel} renderOrder={1}>
                        <MaterialOuterWallNew isPattern={isPattern} visibleSection={"rightlean"} />
                    </mesh>
                }
                {params.p_w_c_n == true && (params.p_b_c_b_r === "Close") && sideWallModelObj?.wainscotModel &&
                    <mesh name="R_L_R_W_wainscot" geometry={sideWallModelObj?.wainscotModel} position={[0.005,0,0]} renderOrder={1}>
                        <MaterialWainScotWallNew isPattern={isPattern} visibleSection={"rightlean"} />
                    </mesh>
                }
                {(params.p_b_c_b_r !== 'Open') && sideWallModelObj && sideWallModelObj?.innerModel && 
                    <mesh name="side" geometry={sideWallModelObj?.innerModel} position={[-wallThickness - 0.01, 0, 0]}>
                        <MaterialInnerWall visibleSection={"rightLean"} />
                    </mesh>
                }
            </group>

            {params.p_b_c_b_r_f !== 'Open' && frontWallModelObj?.outerModel &&
                <mesh name="R_L_F_W" geometry={frontWallModelObj?.outerModel} renderOrder={1}>
                    <MaterialOuterWallNew isPattern={isPattern} visibleSection={"rightlean"} />
                </mesh>
            }
            {
                params.p_b_c_b_r_f !== 'Open' && frontWallModelObj && frontWallModelObj?.innerModel && <mesh name="lean_front_leg_wall" geometry={frontWallModelObj?.innerModel} position={[0, 0, -wallThickness * 3 - 0.01]}>
                    <MaterialInnerWall visibleSection={"rightLean"} />
                </mesh>
            }
            {params.p_w_c_n == true && (params.p_b_c_b_r_f === "Close" || params.p_b_c_b_r_f === "Half Dutch End" || params.p_b_c_b_r_f === "Half End") && frontWallModelObj?.wainscotModel &&
                <mesh name="R_L_F_W_wainscot" geometry={frontWallModelObj?.wainscotModel} position={[0,0,0.005]} renderOrder={1}>
                    <MaterialWainScotWallNew isPattern={isPattern} visibleSection={"rightlean"} />
                </mesh>
            }

            {params.p_b_c_b_r_b !== 'Open' && backWallModelObj?.outerModel &&
                <mesh name="R_L_B_W" geometry={backWallModelObj?.outerModel} renderOrder={1}>
                    <MaterialOuterWallNew isPattern={isPattern} visibleSection={"rightlean"} />
                </mesh>
            }
            {
                params.p_b_c_b_r_b !== 'Open' && backWallModelObj && backWallModelObj?.innerModel && <mesh name="lean_back_leg_wall" geometry={backWallModelObj?.innerModel} position={[0, 0, wallThickness * 2 + 0.01]}>
                    <MaterialInnerWall visibleSection={"rightLean"} />
                </mesh>
            }
            {params.p_w_c_n == true && (params.p_b_c_b_r_b === "Close" || params.p_b_c_b_r_b === "Half Dutch End" || params.p_b_c_b_r_b === "Half End") && backWallModelObj?.wainscotModel &&
                <mesh name="R_L_B_W_wainscot" geometry={backWallModelObj?.wainscotModel} position={[0,0,-0.005]} renderOrder={1}>
                    <MaterialWainScotWallNew isPattern={isPattern} visibleSection={"rightlean"} />
                </mesh>
            }
        </>
    )
}

export default WallModel